export default __webpack_public_path__ + "static/media/classic.11b7c501.svg";